import MessagingChannelSearch from './MessagingChannelSearch';

export default MessagingChannelSearch;
